<ag1-button-small
  variant="primary"
  [variant]="variant"
  tooltip="Info"
  classOverrides="!rounded-full !aspect-square"
  (clickEvent)="infoPopover.toggle($event)"
>
  <span>?</span>
</ag1-button-small>

<p-popover #infoPopover styleClass="[&_.p-popover-content]:!p-0">
  <div
    class="flex w-full max-w-[25rem] flex-col gap-3 rounded bg-steel-blue-500 p-5 text-white"
  >
    <h3 class="mr-6 font-semibold">
      {{ heading }}
    </h3>
    <p class="whitespace-pre-line">
      {{ body }}
    </p>

    <p-button
      size="small"
      severity="contrast"
      variant="text"
      pTooltip="Close"
      class="absolute right-1 top-2"
      (click)="closePanel()"
    >
      <ng-template #icon>
        <svg-icon src="/assets/icons/general/close.svg" />
      </ng-template>
    </p-button>
  </div>
</p-popover>
